import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/BookDetails.js");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/components/Breadcrumb.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/gerelt/front/node_modules/next/dist/client/app-dir/link.js");
